export default "__VITE_ASSET__DCq_6WbK__"